import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x02800000 {
  data: string;
  blockMaxNum: number;
}

export function Command0x02800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    data: "",
    blockMaxNum: 0,
  };

  const [fields, setFields] = React.useState<Form0x02800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x02800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.data) {
      params.data = "";
    }
    if (!params.blockMaxNum) {
      params.blockMaxNum = 0;
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          id="data"
          label="Блок подготовки к записи"
          margin="dense"
          multiline
          fullWidth
          minRows={4}
          value={fields.data}
          onChange={handleChangeField("data")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="blockMaxNum"
          label="Максимальный номер блока прошивки"
          margin="dense"
          fullWidth
          value={fields.blockMaxNum}
          onChange={handleChangeField("blockMaxNum")}
        />
      </FormControl>
    </>
  );
}
